
<script>
import JmFilterEntity from './Entity'

export default {
	name: "JmFilterPerson",

	extends: JmFilterEntity
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FilterWidgets/Person.vue